module.exports = __webpack_public_path__ + "img/media-178@2x.175590af.png";